import { QueryClient } from '@tanstack/react-query';
import { ErrorApi } from './api.ts';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (fallos, error) => {
        // No reintentar errores de negocio/permiso; sí caídas de red (máx. 2)
        if (error instanceof ErrorApi && error.status < 500) return false;
        return fallos < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
});

/** Claves de React Query por módulo (skill modulo-canonico §7: ['<modulo>', sucursal, filtros]). */
export const claves = {
  tasaVigente: ['tasas', 'vigente'] as const,
  tasasHistorial: ['tasas', 'historial'] as const,
  sucursalMia: ['sucursales', 'mia'] as const,
  sucursales: ['sucursales', 'todas'] as const,
  sesionCajaActual: ['caja', 'actual'] as const,
  sesionesCaja: (filtros: Record<string, unknown>) => ['caja', 'sesiones', filtros] as const,
  usuarios: ['usuarios'] as const,
  auditoria: (filtros: Record<string, unknown>) => ['auditoria', filtros] as const,
};
